export default "__VITE_ASSET__DtpmjxhC__"